// export const domain = "https://hamber-3bd04.firebaseio.com"
// export const apiKey = "AIzaSyCdV__mpM9Ej8Sgdv2lmbtamU8FVZ38SFM"


export const domain = "https://react-movies-d3651.firebaseio.com"
export const apiKey = "AIzaSyACPEh_IzZCilQLg3v-sJZuXmdd-NIwmnk"
